import { useApiPrivateRequest } from "@/shared/hooks/useApi";

export const useGeneratePlaybookDescription = () => {
  const {
    data: generatedDescription,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<string>((response) => response);

  const generatePlaybookDescription = async (playbookId: string) => {
    return call(
      `/playbooks/${playbookId}/generateDescription`,
      "POST",
      undefined,
      {
        playbookId,
      },
    );
  };
  return {
    generatedDescription,
    generatePlaybookDescription,
    isLoading,
    isFailed,
  };
};
